import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { selfServiceApi } from '../../services/selfServiceApi';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const DriverPaymentStep: React.FC = () => {
  const { selfServiceData, goBack, sessionId, history } = useWizard();
  const [redirecting, setRedirecting] = useState(false);
  const [body, setBody] = useState<string[] | null>(null);
  useEffect(() => {
    contentApi.getByKey(contentKeys.koerekort.dl_payment).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  const handlePayment = async () => {
    setRedirecting(true);
    if (sessionId) {
      await selfServiceApi.saveBeforeRedirect(sessionId, {
        selfServiceData,
        currentStepId: 'dl_payment',
        history
      }, 'payment');
    }
    const returnUrl = `${window.location.origin}${window.location.pathname}?sessionId=${sessionId}&return=payment&status=success`;
    setTimeout(() => { window.location.href = returnUrl; }, 800);
  };

  return (
    <StepContainer title="Betal for kørekortet">
      {body && <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>}
      <div className="payment-info">
        <p>Betal gebyret for din ansøgning om kørekort.</p>
        <div className="price-box" style={{ backgroundColor: 'var(--bg-color)', padding: '1.5rem', borderRadius: 'var(--border-radius)', marginBottom: '1.5rem' }}>
          <h3>Pris oversigt</h3>
          <p>Gebyr: 280 kr.</p>
          <p><strong>Total: 280 kr.</strong></p>
        </div>
        <button className="btn btn-primary" onClick={handlePayment} disabled={redirecting} data-testid="button-pay">
          {redirecting ? 'Simulerer betaling...' : 'Betal'}
        </button>
      </div>
      <NavigationButtons onBack={goBack} showNext={false} />
    </StepContainer>
  );
};

export default DriverPaymentStep;


